export default __webpack_public_path__ + "static/media/icici-icon.821fa942.svg";